import { render } from "./EditSale.vue?vue&type=template&id=c4ad354e&scoped=true"
import script from "./EditSale.vue?vue&type=script&lang=js"
export * from "./EditSale.vue?vue&type=script&lang=js"

import "./EditSale.vue?vue&type=style&index=0&id=c4ad354e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ad354e"]])

export default __exports__